import { getAuthHeaders, getAuthEmail, userKey } from './auth.js';
import API_BASE_URL from '../api.js';

export const pushAssessments = (key, records) => {
  if (!getAuthEmail()) return;
  fetch(`${API_BASE_URL}/api/user/assessments`, {
    method:  'PUT',
    headers: getAuthHeaders(),
    body:    JSON.stringify({ key, records }),
    cache:   'no-store',
  })
    .then(res => {
      if (!res.ok) console.warn(`[sync:push] HTTP ${res.status} — key=${key}. Data saved locally; will retry on next load.`);
    })
    .catch(err => console.warn(`[sync:push] Network error — key=${key}:`, err.message, '— Data saved locally; will retry on next load.'));
};

export const pullAndMerge = async (key, localStorageKey) => {
  const email = getAuthEmail();
  if (!email) return null;

  let local = [];
  try {
    const raw = window.localStorage.getItem(userKey(localStorageKey));
    if (raw) local = JSON.parse(raw);
  } catch { /* corrupt localStorage — treat as empty */ }

  try {
    const res = await fetch(`${API_BASE_URL}/api/user/assessments/${encodeURIComponent(key)}`, {
      headers: getAuthHeaders(),
      cache:   'no-store',
    });
    if (!res.ok) {
      console.warn(`[sync:pull] HTTP ${res.status} — key=${key}. Falling back to local data.`);
      return local;
    }

    const { records: server } = await res.json();
    if (!Array.isArray(server) || server.length === 0) return local;

    // Merge: server wins on id collision, newest first
    const map = new Map();
    local.forEach(r  => r?.id && map.set(String(r.id), r));
    server.forEach(r => r?.id && map.set(String(r.id), r));

    const merged = Array.from(map.values())
      .sort((a, b) => new Date(b.date) - new Date(a.date));

    try {
      window.localStorage.setItem(userKey(localStorageKey), JSON.stringify(merged));
    } catch { /* QuotaExceededError — skip local write, merged data returned in memory */ }

    return merged;
  } catch (err) {
    console.warn(`[sync:pull] Network error — key=${key}:`, err.message, '— Falling back to local data.');
    return local;
  }
};
